import { Helmet } from "react-helmet-async";
import HomeSlider from "../../components/home/homeSlider/HomeSlider.tsx";
import HomeFirstSection from "../../components/home/homeFirstSection/HomeFirstSection.tsx";
import HomeThirdSection from "../../components/home/homeThirdSection/HomeThirdSection.tsx";
import ServiceList from "../../components/service/servicesList/ServiceList.tsx";

const Home = () => {
  return (
    <div>
      {/* SEO */}
      <Helmet>
        <title>VRN Innovation - Développement Web, Réseaux, Domotique & IT Consulting à Douala</title>
        <meta
          name="description"
          content="VRN Innovation à Douala propose des solutions IT complètes : développement web et mobile, hébergement, installation Starlink, sécurité, réseaux, vidéosurveillance, domotique, marketing digital, formations et consulting IT."
        />
        <meta
          name="keywords"
          content="VRN Innovation, Développement web Douala, Développement mobile Cameroun, Starlink Cameroun, Réseaux, Vidéosurveillance, Domotique, Marketing digital, Formation IT, Consulting informatique"
        />
        <link rel="canonical" href="https://www.vrn-innovation.com/" />
      </Helmet>
      <HomeSlider />
      <HomeFirstSection />
      <HomeThirdSection />
      <ServiceList />
    </div>
  );
};

export default Home;
